import React from "react";
import Label from './LabelUtilsComponet'
import Required from './RequiredComponent'

class InputText extends React.Component {
  state = {
    value: this.props.config.value,
    type: (this.props.config.type !== 'password') ? this.props.config.type : !!this.props.config.showPassword ? 'text' : 'password',
    showPassword: !!this.props.config.showPassword
  }

  cuantos = (text, char) => {
    if (!text.includes(char)) return 0
    return text.split(char).length - 1
  }

  handlerChange = ev => {
    if (this.props.config.type === 'number') {
      if (!(ev.target.value[0] === '-' && ev.target.value.length === 1)) {
        if (this.cuantos(ev.target.value, '.') < 2) {
          if (isNaN(Number(ev.target.value))) return
        } else { return }
      }
    }
    this.props.onChange(
      this.props.config.variable,
      ev.target.value,
      this.props.config.type
    )
  }

  componentDidMount = () => {
    if (this.state.value !== undefined && this.state.value !== null)
      this.handlerChange({ target: { value: this.state.value } });
    if (this.props.config.focusOut && {}.toString.call(this.props.config.focusOut) === '[object Function]') {
      this.refs.input.addEventListener('focusout', this.props.config.focusOut)
    }
    if (this.props.config.focusIn && {}.toString.call(this.props.config.focusIn) === '[object Function]') {
      this.refs.input.addEventListener('focusin', this.props.config.focusIn)
    }
  }

  handleClickShowPassword = () => {
    this.setState({
      showPassword: !this.state.showPassword,
      type: !this.state.showPassword ? 'text' : 'password'
    });
  };

  render() {
    const { config } = this.props;
    return (
      <div className={config.classContainer}>
        <Label {...config} />
        <div className="div-input-form">
          <input
            type={(this.state.type === 'number') ? 'text' : this.state.type}
            className={config.classInput}
            ref="input"
            value={config.value}
            placeholder={config.placeholder}
            onChange={this.handlerChange}
          />
          {
            (config.viewPassword && config.type === 'password') &&
            <>
              {
                this.state.showPassword ?
                  <i className="far fa-eye-slash fa-1x5" onClick={this.handleClickShowPassword}></i> :
                  <i className="far fa-eye fa-1x5" onClick={this.handleClickShowPassword}></i>
              }
            </>
          }
        </div>
          {
            <Required {...config} msg="Diligencie el espacio" />
          }
      </div>
    );
  }
}

export default InputText;
